import type { ApiTableMergedState } from 'components/ApiTable/model/ApiTableModel';

export const selectTableId = (s: ApiTableMergedState): string =>
  s.id ?? s.endpoint.id;
